export default __webpack_public_path__ + "static/testimonialCompanyLogo5-cd5bc9547ed54fd57411454133800e7c.svg";